import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import TasklistsDataGrid from '../../components/DataGrids/TasklistsDataGrid';
import { useSelector } from 'react-redux';
import { RootState } from '../../context/rootReducer';

const styles = {
    note: {
        fontWeight: 400 as const,
        fontSize: '14px'
    },
    oneLiner: {
        border: '1px solid #0D4AFF',
        background: 'rgba(13, 74, 255, 0.06)',
        color: '#000000',
        borderRadius: '8px',
        padding: '10px 12px',
        fontWeight: 700 as const,
        fontSize: '14px',
        marginBottom: '10px',
        alignSelf: 'flex-start',
        display: 'inline-block'
    }
};

const Tasklists: React.FunctionComponent = () => {
    const oneLiner = useSelector((state: RootState) => state.tasklists?.oneLiner || '');

    // Locks horizontal scrolling on the entire page while this route is mounted.
    // Restores the previous value on unmount so other pages behave normally.
    useEffect(() => {
        const prev = document.body.style.overflowX;
        document.body.style.overflowX = 'hidden';
        return () => {
            document.body.style.overflowX = prev;
        };
    }, []);

    return (
        <Container fluid className='ml-2'>
            <div className='incidentHistoryMessage pr-5' style={{ display: 'flex', flexDirection: 'column' }}>
                {oneLiner ? <div style={styles.oneLiner}>{oneLiner}</div> : null}
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }} className='ml-n3 my-2 container-fluid'>
                <p className='incidentHistoryMessage pr-5' style={styles.note}>
                    Note: The data presented here is sourced from Konexus. Please note that not all business
                    lines or regions may be included in this dataset.
                </p>
            </div>
            <div className='container-fluid pr-5'>
                <TasklistsDataGrid />
            </div>
        </Container>
    );
};

export default Tasklists;
